export default __webpack_public_path__ + "static/media/closeModal.7d4ec9ce.svg";